import { render, staticRenderFns } from "./UserLogin2.vue?vue&type=template&id=8e56702c&scoped=true&"
import script from "./UserLogin2.vue?vue&type=script&lang=js&"
export * from "./UserLogin2.vue?vue&type=script&lang=js&"
import style0 from "./UserLogin2.vue?vue&type=style&index=0&id=8e56702c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e56702c",
  null
  
)

export default component.exports